import { Typography } from "antd";
import { FC } from "react";
import AppleStoreSVG from "../../assets/auth/AppleStoreSVG";
import PlayStoreSVG from "../../assets/auth/PlayStoreSVG";
import { useIntl } from "react-intl";

interface MobileAppLinksProps {}

const MobileAppLinks: FC<MobileAppLinksProps> = ({}) => {
  const intl = useIntl();
  const { Link } = Typography;
  return (
    <div className="space-y-4">
      <p className="text-sec-title text-center">
        {intl.formatMessage({ id: "ifUrSearching" })}
      </p>
      <div className="flex justify-center gap-2">
        <Link href={"/"}>
          <AppleStoreSVG />
        </Link>
        <Link href={"/"}>
          <PlayStoreSVG />
        </Link>
      </div>
    </div>
  );
};

export default MobileAppLinks;
